import React from 'react'

import { LastSeenProducts } from './LastSeenProducts'

import type { ProductLayout } from '../../../types/Product'

interface AlreadyVisitedShelfProps {
  data?: {
    isActive: boolean
    shelfLayout?: ProductLayout
  }
}

export function AlreadyVisitedShelf({ data }: AlreadyVisitedShelfProps) {
  const isActive = data?.isActive

  if (!isActive) {
    return null
  }

  return <LastSeenProducts layout={data?.shelfLayout} />
}
